import { Navigate } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import { useT } from '../i18n';

interface AdminRouteProps {
    children: React.ReactNode;
}

/**
 * Route guard that requires both authentication AND superuser privilege.
 * Falls back to auth redirect if not logged in, or a denied screen if
 * the user lacks the is_superuser metadata flag.
 */
export function AdminRoute({ children }: AdminRouteProps) {
    const { user, loading, isSuperuser } = useAuth();
    const t = useT();

    if (loading) {
        return (
            <div className="loading-screen">
                <div className="spinner" />
                <p>{t.common_loading}</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/auth" replace />;
    }

    if (!isSuperuser) {
        return (
            <div className="admin-denied">
                <h2>🔒 {t.admin_deniedTitle}</h2>
                <p>{t.admin_deniedBody}</p>
            </div>
        );
    }

    return <>{children}</>;
}
